export default __webpack_public_path__ + "static/media/hbs-k-bpk-4.1c37c40f.png";